import {Observable, of, ReplaySubject} from 'rxjs';
import {ValidatorFn, Validators} from '@angular/forms';
import {CustomValidators} from '../custom-validators';
import {ValidationPatterns} from '../validation-patterns';
import {map} from "rxjs/operators";

export const CountryList$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
export const CurrencyList$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);


export enum UserFieldType {
  TEXT = 'text',
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  DATE = 'date',
  PHONE = 'phone',
  RADIO = 'radio'
}

export interface UserFieldDescriptor {
  type: UserFieldType;
  label: string;
  validators?: ValidatorFn[];
  options?: Observable<[string, string][]>;
}

export const userFields: Map<string, UserFieldDescriptor> = new Map<string, UserFieldDescriptor>([
  ['gender', {
    label: 't.gender',
    type: UserFieldType.RADIO,
    validators: [Validators.required],
    options: of([
      ['m', 'label.male'],
      ['f', 'label.female']
    ])
  }],
  ['date_of_birth', {
    label: 'DD / MM / YYYY',
    type: UserFieldType.DATE,
    validators: [Validators.required, Validators.pattern(ValidationPatterns.dateOfBirth), CustomValidators.eighteenYearsOld],
  }],
  ['first_name', {
    label: 't.first-name',
    type: UserFieldType.TEXT,
    validators: [Validators.required, Validators.pattern(ValidationPatterns.lettersWithoutNumbers)],
  }],
  ['last_name', {
    label: 't.last-name',
    type: UserFieldType.TEXT,
    validators: [Validators.required, Validators.pattern(ValidationPatterns.lettersWithoutNumbers)],
  }],
  ['mobile_phone', {
    label: 't.phone-number',
    type: UserFieldType.PHONE,
    validators: [Validators.required, Validators.minLength(5)],
  }],
  ['city', {
    label: 't.city',
    type: UserFieldType.TEXT,
    validators: [Validators.required],
  }],
  ['address', {
    label: 't.address',
    type: UserFieldType.TEXT,
    validators: [Validators.required],
  }],
  ['postal_code', {
    label: 't.zip-code',
    type: UserFieldType.TEXT,
    validators: [Validators.required],
  }],
  ['country', {
    label: 't.country',
    type: UserFieldType.SELECT,
    options: CountryList$.pipe(
      map(list => list.map(country => [country.short.toUpperCase(), country.name]))
    ),
    validators: [Validators.required],
  }],
  ['currency', {
    label: 't.currency',
    type: UserFieldType.SELECT,
    options: CurrencyList$.pipe(
      map(list => list.map(currency => [currency.code, currency.code]))
    ),
    validators: [Validators.required],
  }],
  ['state', {
    label: 'labl.state',
    type: UserFieldType.SELECT,
    validators: [Validators.required],
  }],
]);
